// extracted by mini-css-extract-plugin
module.exports = {"truncate":"_1SBejEbD2O","icon":"_3L6QQtPsdb","time":"_1o9FfPKy46","id":"_2oyxPH6Vf2","type":"_2t4umWHVTK","error-description":"_2l2brJYv3f","errorDescription":"_2l2brJYv3f","data":"OeIbd-Chmq"};
    if(module.hot) {
      // 1597843270228
      var cssReload = require("!../../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  